import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { AssetInBaseAsset } from '../models/assets-in-base-asset/AssetInBaseAsset';

import { NgForm } from '@angular/forms';
import { API_SETTINGS } from './API_SETTINGS';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'AssetInBaseAsset';

@Injectable({
  providedIn: 'root'
})
export class ApiAssetInBaseAssetService {

  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getAssetsInBaseAsset(): Observable<AssetInBaseAsset[]> {
    const url = apiUrl + '/GetAssetsInBaseAsset';
    return this.http.get<AssetInBaseAsset[]>(url).pipe();
  }

  getAssetInBaseAsset(id: number): Observable<AssetInBaseAsset> {
    const url = `${apiUrl}/GetAssetInBaseAsset/${id}`;
    return this.http.get<AssetInBaseAsset>(url).pipe();
  }

  addAssetInBaseAsset(AssetInBaseAsset: AssetInBaseAsset): Observable<AssetInBaseAsset> {
    const url = apiUrl + '/PostAssetInBaseAsset';
    return this.http.post<AssetInBaseAsset>(url, AssetInBaseAsset, httpOptions).pipe();
  }

  updateAssetInBaseAsset(id: number, AssetInBaseAsset: AssetInBaseAsset): Observable<AssetInBaseAsset> {
    const url = `${apiUrl}/PutAssetInBaseAsset/${id}`;
    return this.http.put(url, AssetInBaseAsset, httpOptions).pipe(
      tap((AssetInBaseAssetRes: AssetInBaseAsset) => true ), //console.log()),
      catchError(this.handleError<AssetInBaseAsset>('updateAssetInBaseAsset'))
    )
  }

  deleteAssetInBaseAsset(id: number): Observable<AssetInBaseAsset> {
    const url = `${apiUrl}/DeleteAssetInBaseAsset/${id}`;
    return this.http.delete<AssetInBaseAsset>(url, httpOptions).pipe();
  }

  assetInBaseAssetExists(id: number): Observable<boolean> {
    const url = `${apiUrl}/AssetInBaseAssetExists/${id}`;
    return this.http.get<boolean>(url, httpOptions).pipe();
  }

  getAssetsInBaseAssetWithBaseAssetId(baseAssetId: number): Observable<AssetInBaseAsset[]> {
    const url = apiUrl + `/GetAssetsInBaseAssetWithBaseAssetId/${baseAssetId}`;
    return this.http.get<AssetInBaseAsset[]>(url, httpOptions).pipe();
  }

  getAssetsInBaseAssetWithLinkedBaseAssetId(linkedBaseAssetId: number): Observable<AssetInBaseAsset[]> {
    const url = apiUrl + `/GetAssetsInBaseAssetWithLinkedBaseAssetId/${linkedBaseAssetId}`;
    return this.http.get<AssetInBaseAsset[]>(url, httpOptions).pipe();
  }

  getAssetsInBaseAssetWithBaseAssetIds(baseAssetIds: number[]): Observable<AssetInBaseAsset[]> {
    const url = apiUrl + '/GetAssetsInBaseAssetWithBaseAssetIds';
    return this.http.post<AssetInBaseAsset[]>(url, baseAssetIds, httpOptions).pipe();
  }

  getAssetInBaseAssetWithBaseAssetId(sceneId: number): Observable<AssetInBaseAsset[]> {
    const url = `${apiUrl}/GetAssetsInBaseAssetWithBaseAssetId/${sceneId}`;
    return this.http.get<AssetInBaseAsset[]>(url).pipe();
  }
}
